<template>
  <div class="box" style="padding: 0px 50px">
    <p class="page_title">违章管理</p>
    <div
        class="content_box"
        element-loading-text="正在查询,请稍候..."
    >
      <div class="query_box">
        <el-form :model="form" ref="form" label-position="top" size="mini">
          <el-row :gutter="20">
            <el-col :span="4">
              <el-form-item label="姓名：" >
                <el-input
                        v-model="form.carOwner"
                        placeholder="请输入姓名"
                        clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="手机号：" >
                <el-input
                        v-model="form.phone"
                        placeholder="请输入手机号"
                        clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="车牌号：" >
                <el-input
                    v-model="form.carNo"
                    placeholder="请输入车牌号"
                    clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="违章地点：">
                <el-input
                    v-model="form.locationId"
                    placeholder="请输入违章地点"
                    clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="违章类型：">
                <el-select
                    v-model="form.type"
                    placeholder="请选择违章类型"
                    clearable
                >
                  <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="违章时间：">
                <el-date-picker
                    v-model="form.timeRange"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions"
                    style="width: 100%;"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="text-align: right;">
              <el-button size="medium" type="primary" icon="el-icon-search" @click="qryInfo()">查询</el-button>
              <el-button size="medium" icon="el-icon-refresh" @click="resetForm()">重置</el-button>
              <el-button size="medium" type="warning" icon="el-icon-setting" @click="handleViolationSetting()">违章设置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="table_box">
      <el-table
          :data="tableData"
          v-loading="loading"
          element-loading-text="正在加载，请稍候..."
          border
          style="width: 100%"
      >
        <el-table-column prop="carOwner" label="车主姓名" width="" show-overflow-tooltip  align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="" show-overflow-tooltip  align="center"></el-table-column>
        <el-table-column prop="carNo" label="车牌号" width="" show-overflow-tooltip  align="center"></el-table-column>
        <el-table-column prop="type" label="违章类型" width="" show-overflow-tooltip  align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 100801">超速</span>
            <span v-if="scope.row.type == 100802">违停</span>
          </template>
        </el-table-column>
        <el-table-column prop="triggerTime" label="违章时间" width=""  align="center"></el-table-column>
        <el-table-column prop="triggerPosition" label="违章地点" width="" show-overflow-tooltip  align="center"></el-table-column>
        <el-table-column prop="speed" label="行驶速度" width="" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.speed">{{ scope.row.speed }} km/h</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="mscore" label="本次违章记分" width="" align="center"></el-table-column>
        <el-table-column prop="levelScore" label="记分后的总分" width="" align="center"></el-table-column>
        <el-table-column prop="campus" label="校区" width="" align="center"></el-table-column>
<!--        <el-table-column prop="sumBreakRule" label="累积违章次数" width="" align="center"></el-table-column>-->
        <el-table-column fixed="right" label="操作" width="" align="center">
          <template slot-scope="scope">
            <el-button
                @click="handleViewDetail(scope.row)"
                type="primary"
                size="small"
                icon="el-icon-view"
            >查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :page.sync="page" @pageChange="qryInfo" />
      
      <!-- 详情对话框 -->
      <el-dialog
          title="违章记录详情"
          :visible.sync="dialogVisible"
          width="70%"
          :close-on-click-modal="false"
      >
        <el-descriptions :column="2" border v-if="currentRow">
          <el-descriptions-item label="车主姓名">{{ currentRow.carOwner }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ currentRow.phone }}</el-descriptions-item>
          <el-descriptions-item label="车牌号">{{ currentRow.carNo }}</el-descriptions-item>
          <el-descriptions-item label="违章类型">{{ currentRow.type || '-' }}</el-descriptions-item>
          <el-descriptions-item label="违章时间">{{ currentRow.triggerTime }}</el-descriptions-item>
          <el-descriptions-item label="违章地点">{{ currentRow.triggerPosition }}</el-descriptions-item>
          <el-descriptions-item label="行驶速度">{{ currentRow.speed ? currentRow.speed + ' km/h' : '-' }}</el-descriptions-item>
          <el-descriptions-item label="违章记分">{{ currentRow.mscore }}</el-descriptions-item>
          <el-descriptions-item label="记分后的分数">{{ currentRow.levelScore }}</el-descriptions-item>
          <el-descriptions-item label="校区">{{ currentRow.campus }}</el-descriptions-item>
<!--          <el-descriptions-item label="累积违章次数">{{ currentRow.sumBreakRule }}</el-descriptions-item>-->
          <el-descriptions-item label="违章图片" :span="2">
            <div v-if="currentRow.photoUrl" style="text-align: center;">
              <el-image
                :src="getImageUrl(currentRow.photoUrl)"
                :preview-src-list="[getImageUrl(currentRow.photoUrl)]"
                fit="contain"
                style="width: 300px; height: 200px; cursor: pointer;"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i> 图片加载失败
                </div>
              </el-image>
            </div>
            <span v-else>-</span>
          </el-descriptions-item>
        </el-descriptions>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

      <!-- 违章设置对话框 -->
      <el-dialog
          title="违章设置"
          :visible.sync="settingDialogVisible"
          width="50%"
          :close-on-click-modal="false"
      >
        <el-form :model="violationSetting" ref="violationSettingForm" label-width="180px" size="small" label-position="top">
          <el-divider content-position="left">超速设置</el-divider>
          <el-form-item label="超速扣分1挡 (37-45km/h)：">
            <el-input-number
              v-model="violationSetting.overSpeedScoreLevel1"
              :min="0"
              :max="12"
              placeholder="请输入扣分值"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="超速扣分2挡 (46km/h及以上)：">
            <el-input-number
              v-model="violationSetting.overSpeedScoreLevel2"
              :min="0"
              :max="12"
              placeholder="请输入扣分值"
            ></el-input-number>
          </el-form-item>
          <el-divider content-position="left">违停设置</el-divider>
          <el-form-item label="违停扣分：">
            <el-input-number
              v-model="violationSetting.illegalParkingScore"
              :min="0"
              :max="12"
              placeholder="请输入扣分值"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="违停是否发送短信通知：">
            <el-switch
              v-model="violationSetting.illegalParkingSendMessage"
              active-text="是"
              inactive-text="否"
            ></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="settingDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveViolationSetting()" :loading="saving">保 存</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import index from "@/components/mixins/index";
import { findCarBreakrule, getViolationSetting, setViolationSetting } from "./api/index"

export default {
  mixins: [index],
  data() {
    return {
      loading: false,
      dialogVisible: false,
      currentRow: null,
      settingDialogVisible: false,
      saving: false,
      form: {
        carNo: "",
        locationId: "",
        type: "",
        timeRange: []
      },
      tableData: [],
      violationSetting: {
        illegalParkingScore: 0,
        illegalParkingSendMessage: false,
        overSpeedScoreLevel1: 0,
        overSpeedScoreLevel2: 0
      },
      typeOptions: [
        {value: "100801", label: "超速"},
        {value: "100802", label: "违停"},
      ],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  methods: {
    // 查询违章记录
    qryInfo() {
      this.loading = true;
      let params = {
        current: this.page.pageNum,
        size: this.page.pageSize
      };

      // 添加查询条件
      if (this.form.carNo) {
        params.carNo = this.form.carNo;
      }
      if (this.form.locationId) {
        params.triggerPosition = this.form.locationId;
      }
      if (this.form.type) {
        params.type = this.form.type;
      }
      if (this.form.timeRange && this.form.timeRange.length === 2) {
        params.startTime = this.form.timeRange[0];
        params.endTime = this.form.timeRange[1];
      }

      findCarBreakrule(params)
          .then((res) => {
            if (res.data && res.data.code === 20000) {
              this.tableData = res.data.data.records || [];
              this.page.total = res.data.data.total || 0;
            } else {
              this.$message.warning(res.data.message || '查询失败');
              this.tableData = [];
              this.page.total = 0;
            }
          })
          .catch((err) => {
            console.error('查询出错:', err);
            this.$message.error('服务器发生错误，请联系系统管理员');
            this.tableData = [];
            this.page.total = 0;
          })
          .finally(() => {
            this.loading = false;
          });
    },

    // 重置表单
    resetForm() {
      this.form = {
        carNo: "",
        locationId: "",
        type: "",
        timeRange: []
      };
      this.page.pageNum = 1;
      this.qryInfo();
    },

    // 查看详情
    handleViewDetail(row) {
      this.currentRow = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    
    // 获取图片 URL（通过代理）
    getImageUrl(photoUrl) {
      if (!photoUrl) return '';
      // 如果以 http 或 https 开头，需要通过后端代理访问
      if (photoUrl.startsWith('http://') || photoUrl.startsWith('https://')) {
        return `/user/smartCarBreakrule/getImage?url=${encodeURIComponent(photoUrl)}`;
      } else {
        if (photoUrl.startsWith('/')) {
          photoUrl = photoUrl.substring(1);
        }
        return `/user/${photoUrl}`
      }
      return photoUrl;
    },

    // 打开违章设置对话框
    handleViolationSetting() {
      this.settingDialogVisible = true;
      this.loadViolationSetting();
    },

    // 加载违章设置
    loadViolationSetting() {
      this.saving = true;
      getViolationSetting()
        .then((res) => {
          if (res.data && res.data.code === 20000) {
            const data = res.data.data || {};
            this.violationSetting = {
              illegalParkingScore: data.illegalParkingScore || 0,
              illegalParkingSendMessage: data.illegalParkingSendMessage !== undefined ? data.illegalParkingSendMessage : false,
              overSpeedScoreLevel1: data.overSpeedScoreLevel1 || 0,
              overSpeedScoreLevel2: data.overSpeedScoreLevel2 || 0
            };
          } else {
            this.$message.warning(res.data.message || '获取设置失败');
          }
        })
        .catch((err) => {
          console.error('获取设置出错:', err);
          this.$message.error('服务器发生错误，请联系系统管理员');
        })
        .finally(() => {
          this.saving = false;
        });
    },

    // 保存违章设置
    saveViolationSetting() {
      this.$refs.violationSettingForm.validate((valid) => {
        if (valid) {
          this.saving = true;
          setViolationSetting(this.violationSetting)
            .then((res) => {
              if (res.data && res.data.code === 20000) {
                this.$message.success('保存成功');
                this.settingDialogVisible = false;
              } else {
                this.$message.warning(res.data.message || '保存失败');
              }
            })
            .catch((err) => {
              console.error('保存设置出错:', err);
              this.$message.error('服务器发生错误，请联系系统管理员');
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    }
  },
  components: {},
  mounted() {
    this.qryInfo();
  }
}
</script>
<style lang="scss">
.el-table .warning-row {
  background: oldlace;
  color: #8e000a;
}
</style>
<style scoped lang="scss">
.box {
  width: 100%;
  box-sizing: border-box;
  background: #f2f2f2;
  padding: 0 20px 20px 50px;

  .page_title {
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    border-left: 10px solid #3399ff;
    font-size: 16px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
    color: #666666;
    font-weight: 700;
    padding-left: 15px;
  }

  .content_box {
    box-sizing: border-box;
    margin-top: 20px;
    width: 100%;
  }

  .query_box {
    background: #ffffff;
    padding: 20px;
    border-radius: 4px;
  }
}
</style>
